import React from "react";
import DetailIcon from "../../../../../../images/sidebar/item-details-logo.svg";
import { inject, observer } from "mobx-react";
import Item from "../../../../../../images/products/selected-item.svg";
import Category from "../../../../../../images/products/category.svg";
//import Money from "../../../../../../images/sidebar/dollar-royal-blue.svg";
import {
  CountryWithStateModel,
  DonationIncludedSectionModel,
  DonationOptionsPageModel,
  DonationRagnesModel,
  RelatedItemsModel,
} from "../../../shared/models";
import {
  CollapsiblePanel,
  CustomLabel,
  FlexContainer,
  IconButton,
  Input,
  IOption,
  RedButton,
  SingleSelect,
} from "@mindmemobile/mm-shared-global";
import { DonationStore } from "../../../shared/store";
import { CategoryService, RelatedItemsService } from "../../../shared/services";
import {
  ItemHeader,
  RelatedItemContent,
  RelatedItemContentRender,
} from "../../../shared/components";
import {
  DescriptionCell,
  ItemContainer,
  LabelCell,
  ProductOptionWrapper,
} from "../../../shared/styles";

interface IProps {
  donationStore?: DonationStore;
  categoryService?: CategoryService;
  countriesWithState: CountryWithStateModel[];  
  donationId?: string | null;
}
type OptionsData = {
  icon: string;
  name: string;
  onClick: (index: number) => void;
};
@inject("categoryService", "donationStore")
@observer
export default class DonationOptionsPage extends React.Component<IProps> {
  constructor(props: IProps) {
    super(props);
    this.onSelectItem = this.onSelectItem.bind(this);
    this.onShowCategories = this.onShowCategories.bind(this);
    this.onShowCredits = this.onShowCredits.bind(this);
  }

  get clonedRanges() {
    const clonedRanges =
      this.optionsPageData?.includedItems.ranges.map((r) => {
        return new DonationRagnesModel({ ...r });
      }) || [];

    return clonedRanges;
  }
  onSelectItem(index: number) {
    const clonedRanges = this.clonedRanges;
    clonedRanges[index].item.showSelectItems = true;
    clonedRanges[index].item.showSelectItemsPopup = true;
    this.updateRanges(clonedRanges);
  }

  onShowCategories(index: number) {
    const clonedRanges = this.clonedRanges;
    clonedRanges[index].item.showCategories = true;
    this.updateRanges(clonedRanges);
  }

  onShowCredits(index: number) {
    const clonedRanges = this.clonedRanges;
    clonedRanges[index].item.showAccountCredits = true;
    this.updateRanges(clonedRanges);
  }

  updateRanges(ranges: DonationRagnesModel[]) {
    this.props.donationStore?.updateOptionsPage(
      new DonationOptionsPageModel({
        ...this.optionsPageData,
        includedItems: new DonationIncludedSectionModel({
          ...this.optionsPageData?.includedItems,
          ranges: ranges,
        }),
      })
    );
  }

  select(
    hasError: boolean,
    selectedKey: string,
    options: any[],
    onChange: (id: string) => void,
    className?: string
  ) {
    return (
      <SingleSelect
        hasError={hasError}
        selectedKey={selectedKey}
        nameKeys={["label"]}
        valueKeys={["value"]}
        onChange={(option) => onChange(option.value)}
        options={[options]}
        searchable={false}
        className={`options-custom-dropdown ${className} `}
      />
    );
  }

  get options(): OptionsData[] {
    return [
      {
        icon: Item,
        name: "Select Items",
        onClick: this.onSelectItem,
      } as OptionsData,
      {
        icon: Category,
        name: "Category",
        onClick: this.onShowCategories,
      } as OptionsData,
      //hide due to requirement change
      // {
      //   icon: Money,
      //   name: "Issue Credit",
      //   onClick: this.onShowCredits,
      // } as OptionsData,
    ];
  }

  get anySpecificOptions(): IOption[] {
    return [
      {
        label: "Any",
        value: "Any",
      },
      {
        label: "Specific",
        value: "Specific",
      },
    ];
  }

  get ranges(): IOption[] {
    return Array.from({ length: 4 }, (_, i) => {
      const value = i + 2;
      return {
        label: value.toString(),
        value: value.toString(),
      };
    });
  }

  get optionsPageData() {
    return this.props.donationStore?.optionsPage;
  }

  totalRanges(totalRanges: number): DonationRagnesModel[] {
    const ranges: DonationRagnesModel[] = [];
    Array.from({ length: totalRanges }, (_, i) => {
      const rangeExists =
        this.optionsPageData &&
        this.optionsPageData.includedItems.ranges.length > i
          ? this.optionsPageData?.includedItems?.ranges[i]
          : null;

      if (rangeExists) {
        ranges.push(new DonationRagnesModel(rangeExists));
      } else {
        ranges.push(new DonationRagnesModel());
      }
    });

    return ranges;
  }

  onTotalRangesChange(value: string) {
    const totalRanges = parseInt(value);

    this.props.donationStore?.updateOptionsPage(
      new DonationOptionsPageModel({
        ...this.optionsPageData,
        includedItems: new DonationIncludedSectionModel({
          ...this.optionsPageData?.includedItems,
          totalRanges: totalRanges,
          ranges: this.totalRanges(totalRanges),
        }),
      })
    );
  }

  updateAnyOrSpecifice(any: boolean) {
    this.props.donationStore?.updateOptionsPage(
      new DonationOptionsPageModel({
        ...this.optionsPageData,
        includedItems: new DonationIncludedSectionModel({
          ...this.optionsPageData?.includedItems,
          any: any,
          ranges: this.totalRanges(
            this.optionsPageData?.includedItems.totalRanges || 2
          ),
        }),
      })
    );
  }

  get includedSection() {
    const description2 = this.optionsPageData?.includedItems.any ? (
      <CustomLabel>donation amount.</CustomLabel>
    ) : (
      <FlexContainer
        gap="10px"
        alignItems="center"
        className="donation-number-select"
      >
        <CustomLabel> donation amount in</CustomLabel>
        {this.select(
          false,
          this.optionsPageData?.includedItems?.totalRanges?.toString() || "",
          this.ranges,
          (value) => this.onTotalRangesChange(value)
        )}{" "}
        <CustomLabel> donation ranges.</CustomLabel>
      </FlexContainer>
    );

    const description = (
      <>
        <FlexContainer alignItems="center" spacing={10}>
          <div>
            This will be included at <b>no cost</b> based on
          </div>
          <div className="donation-string-selector">
            {this.select(
              false,
              this.optionsPageData?.includedItems.any ? "Any" : "Specific",
              this.anySpecificOptions,
              (value) => this.updateAnyOrSpecifice(value === "Any"),
              "dpdn-no-border text-royal-blue any-all-included-dpdn"
            )}
          </div>
          {this.optionsPageData?.includedItems.any && description2}
        </FlexContainer>
      </>
    );

    if (this.optionsPageData?.includedItems.any) {
      return (
        <>
          <RelatedItemContent
            hideIssueCredit={true}
            sourceId={this.props.donationId || ""}
            item={this.optionsPageData.includedItems.item}
            countriesWithState={this.props.countriesWithState}
            label="Included"
            multiplePriceSelection={false}
            description={description}
            showOptions={
              !this.optionsPageData.includedItems.item.hasSelectedAnOption
            }
            onUpdate={(data: RelatedItemsModel) =>
              this.props.donationStore?.updateOptionsPage(
                new DonationOptionsPageModel({
                  ...this.optionsPageData,
                  includedItems: new DonationIncludedSectionModel({
                    ...this.optionsPageData?.includedItems,
                    item: new RelatedItemsModel(data),
                  }),
                })
              )
            }
            reltedItemService={
              this.props.donationStore?.relatedItemService ||
              new RelatedItemsService()
            }
            categoryService={this.props.categoryService}
          />
          {this.optionsPageData?.includedItems.hasError("item") && (
            <div style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
              Select Item
            </div>
          )}
        </>
      );
    }

    return (
      <FlexContainer className="label-description-row padding-left-40-row">
        <LabelCell>
          <CustomLabel fontWeight="600">Included</CustomLabel>
        </LabelCell>
        <DescriptionCell>
          <FlexContainer
            fxLayout="column"
            spacing={10}
            className="padding-left-40"
          >
            <div>
              <FlexContainer spacing={10}>
                <div>{description}</div>
                <div>{description2}</div>
              </FlexContainer>
            </div>
            {!this.optionsPageData?.includedItems.any && (
              <>{this.rangesOptions}</>
            )}
          </FlexContainer>
        </DescriptionCell>
      </FlexContainer>
    );
  }

  itemOptions(index = -1) {
    return (
      <FlexContainer alignItems="center" spacing={20}>
        {this.options.map((o, idx) => {
          return (
            <IconButton key={idx} onClick={() => o.onClick(index)}>
              <img src={o.icon} />
              <label htmlFor="">{o.name}</label>
            </IconButton>
          );
        })}
      </FlexContainer>
    );
  }

  get recommendedSection() {
    if (!this.optionsPageData) return null;
    const description = (
      <CustomLabel lineHeight="40px">
        This will be <b>recommended</b> when donation is made.
      </CustomLabel>
    );

    return (
      <RelatedItemContent
        hideIssueCredit={true}
        sourceId={this.props.donationId || ""}
        item={this.optionsPageData.recommendedItems}
        countriesWithState={this.props.countriesWithState}
        label="Recommended"
        description={description}
        multiplePriceSelection={true}
        showOptions={!this.optionsPageData.recommendedItems.hasSelectedAnOption}
        onUpdate={(data: RelatedItemsModel) =>
          this.props.donationStore?.updateOptionsPage(
            new DonationOptionsPageModel({
              ...this.optionsPageData,
              recommendedItems: new RelatedItemsModel(data),
            })
          )
        }
        reltedItemService={
          this.props.donationStore?.relatedItemService ||
          new RelatedItemsService()
        }
        categoryService={this.props.categoryService}
      />
    );
  }

  onReset(isIncluded: boolean, isRecommended: boolean) {
    this.props.donationStore?.updateOptionsPage(
      new DonationOptionsPageModel({
        ...this.optionsPageData,
        includedItems: isIncluded
          ? new DonationIncludedSectionModel()
          : this.optionsPageData?.includedItems,
        recommendedItems: isRecommended
          ? new RelatedItemsModel()
          : this.optionsPageData?.recommendedItems,
      })
    );
  }

  get rangesOptions() {
    if (!this.optionsPageData) return null;
    const { totalRanges } = this.optionsPageData.includedItems;

    return this.optionsPageData?.includedItems.ranges.map((range, idx) => {
      const previous =
        idx > 0 && totalRanges > 1
          ? this.optionsPageData?.includedItems.ranges[idx - 1]
          : null;
      const isLast = totalRanges === idx + 1;
      const isOptionSelected = range.item.hasSelectedAnOption;
      return (
        <>
          <FlexContainer
            fxLayout="column"
            className={`donation-option-buttons ${!isOptionSelected ? "" : "border-grey"}`}
          >
            <div
              className={`full-width ${this.optionsPageData?.includedItems.hasRangeError("item", idx) ? "error-border" : ""}`}
            >
              <FlexContainer
                key={idx}
                spacing={10}
                fxLayout="row"
                justifyContent="space-between"
                alignItems="center"
                className={`padding-left-40-buttons ${!isOptionSelected ? "" : "curved-border"}`}
              >
                <div>
                  <FlexContainer alignItems="center" spacing={8}>
                    {isLast ? (
                      ""
                    ) : (
                      <>
                        <div className="range-starts">${range.start} </div> -
                        {/* <div className="range-max"> ${range.max}</div> */}
                      </>
                    )}

                    {!isLast && (
                      <Input
                        type="number"
                        error={
                          this.optionsPageData?.includedItems.hasRangeError(
                            "max",
                            idx
                          ) ||
                          this.optionsPageData?.includedItems.hasRangeError(
                            "start",
                            idx
                          )
                        }
                        onChange={(e) =>
                          this.onRangeChange(idx, e.target.value)
                        }
                        value={range.max}
                        className="styled-input donation-options-input"
                      />
                    )}
                  </FlexContainer>
                  {previous && isLast && (
                    <div>
                      {previous.max ? parseFloat(previous.max) + 1 : ""} or more
                    </div>
                  )}
                </div>
                {!isOptionSelected ? (
                  <div> {this.itemOptions(idx)} </div>
                ) : (
                  <RedButton
                    minWidth="80px"
                    className="clear-btn"
                    onClick={() => this.onReset(true, false)}
                  >
                    Clear
                  </RedButton>
                )}
              </FlexContainer>
              <RelatedItemContentRender
                sourceId={this.props.donationId || ""}
                multiplePriceSelection={false}
                reltedItemService={
                  this.props.donationStore?.relatedItemService ||
                  new RelatedItemsService()
                }
                countriesWithState={this.props.countriesWithState}
                categoryService={this.props.categoryService}
                item={range.item}
                onUpdate={(data: RelatedItemsModel) =>
                  this.updateRangeItems(idx, data)
                }
              />
            </div>
            {/* {this.optionsPageData?.includedItems.hasRangeError('item', idx) && (
                            <CustomLabel color="#f00" fontSize="12px">
                                Select Item
                            </CustomLabel>
                        )} */}
          </FlexContainer>
        </>
      );
    });
  }

  onRangeChange(index: number, value: string) {
    const clonedRanges =
      this.optionsPageData?.includedItems.ranges.map((r) => {
        return new DonationRagnesModel({ ...r });
      }) || [];

    clonedRanges[index].max = value;
    this.props.donationStore?.updateOptionsPage(
      new DonationOptionsPageModel({
        ...this.optionsPageData,
        includedItems: new DonationIncludedSectionModel({
          ...this.optionsPageData?.includedItems,
          ranges: clonedRanges,
        }),
      })
    );
  }

  updateRangeItems(index: number, data: RelatedItemsModel) {
    const clonedRanges =
      this.optionsPageData?.includedItems.ranges.map((r) => {
        return new DonationRagnesModel({ ...r });
      }) || [];

    clonedRanges[index].item = data;
    this.props.donationStore?.updateOptionsPage(
      new DonationOptionsPageModel({
        ...this.optionsPageData,
        includedItems: new DonationIncludedSectionModel({
          ...this.optionsPageData?.includedItems,
          ranges: clonedRanges,
        }),
      })
    );
  }

  render() {
    return (
      <ProductOptionWrapper>
        <ItemContainer padding="0px 25px 0px 0px">
          <ItemHeader header={"Donation Options"} />
          <CollapsiblePanel
            title="Related Items"
            className="collapsed-labels donation-collapsed"
            imgSrc={DetailIcon}
            isShowInfoIcon
          >
            <FlexContainer fxLayout="column" spacing={20}>
              {this.includedSection}
              {this.recommendedSection}
            </FlexContainer>
          </CollapsiblePanel>
        </ItemContainer>
      </ProductOptionWrapper>
    );
  }
}
